import * as actions from './actions';
import { withApi } from 'piral-core';
import { getPageLayouts, withPageLayouts } from './utils';
/**
 * Creates new Pilet API extensions for dealing with page layouts.
 */
export function createPageLayoutsApi(config = {}) {
    const { layouts = {}, fallback } = config;
    return (context) => {
        const findPageLayout = (name) => context.readState((s) => s.registry.pageLayouts[name]);
        context.defineActions(actions);
        context.dispatch(withPageLayouts(getPageLayouts(layouts), fallback));
        return (api) => {
            const pilet = api.meta.name;
            return {
                registerPageLayout(name, pageLayout) {
                    const current = findPageLayout(name);
                    if (!current || current.pilet === pilet) {
                        const component = withApi(context, pageLayout, api, 'pageLayout');
                        context.registerPageLayout(name, {
                            component,
                            pilet,
                        });
                    }
                    return () => api.unregisterPageLayout(name);
                },
                unregisterPageLayout(name) {
                    const current = findPageLayout(name);
                    if (current?.pilet === pilet) {
                        context.unregisterPageLayout(name);
                    }
                },
            };
        };
    };
}
//# sourceMappingURL=create.js.map